import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { DeclarationOethCalculeeDto } from "../../../dto/GenApi.iNotPaie.Dto/DeclarationOethCalculeeDto";
import { DeclarationOethDto } from "../../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { EtatDeclarationOeth } from "../../../dto/GenApi.iNotPaie.Dto/EtatDeclarationOeth";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

interface rapportObject {
	declaration: DeclarationOethDto,
	readOnly: boolean
}

@Component
export default class ModalRapportOeth extends Vue {
	public declarationOETH!: DeclarationOethDto;
	public isReadOnly = false;

	public declarationCalculeeOETH: DeclarationOethCalculeeDto = {
    	Id: 0,
    	AccordAgree: false,
    	AccueilBoethSurQuatreAns: false,
    	Annee: 0,
    	AnneeDsnMetadata: 0,
    	BoethExterneMoinsDeCinquanteAns: 0,
    	BoethExternePlusDeCinquanteAns: 0,
    	BoethExternePlusDeCinquanteAnsSurvalorise: 0,
    	BoethInterneMoinsDeCinquanteAns: 0,
    	BoethInternePlusDeCinquanteAns: 0,
    	BoethInternePlusDeCinquanteAnsSurvalorise: 0,
    	IdSociete: 0,
    	CoefficientEntreprise: 0,
    	DepenseAccompagnementBoeth: 0,
    	DepenseCompensationHandicap: 0,
    	DepenseDiagnosticEtTravauxBoeth: 0,
    	DepensePartenariatAssociation: 0,
    	DepenseParticipationEvenement: 0,
    	DepenseProfessionnalisation: 0,
    	DepenseSousTraitance: 0,
    	EffectifEcap: 0,
    	EffectifTotal: 0,
    	Etat: EtatDeclarationOeth.NonCreee,
    	IdDsnMetadataFk: 0,
    	MoisDsnMetadata: 0,
    	MontantBudgetAccord: 0,
    	MontantContributionAnneePrecedente: 0,
    	MontantContributionBrute: 0,
    	MontantContributionNetteApresEcretement: 0,
    	MontantContributionReelleDue: 0,
    	MontantContributionNetteAvantEcretement: 0,
    	MontantDeductionBoethExterneMoinsDeCinquanteAns: 0,
    	MontantDeductionBoethExternePlusDeCinquanteAns: 0,
    	MontantDeductionBoethInterneMoinsDeCinquanteAns: 0,
    	MontantDeductionBoethInternePlusDeCinquanteAns: 0,
    	MontantDeductionDepenseDirecte: 0,
    	MontantDeductionEcap: 0,
    	MontantDeductionSousTraitance: 0,
    	NombreBoethManquant: 0,
    	NombreEmployesBoeth: 0,
    	NombreEmployesBoethRequis: 0,
    	RecoursSousTraitanceSurQuatreAns: false,
    	TauxEmployesBoeth: 0
	};

	public init(item: rapportObject): void {
		this.isReadOnly = item.readOnly;
    	this.declarationOETH = item.declaration;
    	this.setData(item.declaration.Id);
	}

	private setData(id: number): void {
    	ServicesFactoryInstance.DeclarationOethService.GetDeclarationOethCalculee(id, (data) => {
    		this.declarationCalculeeOETH = data;
    		this.$forceUpdate();
    	});
	}

	public back(): void {
		const itemBack: rapportObject = {
			declaration: this.declarationOETH,
			readOnly: this.isReadOnly
		};

    	this.$emit("back", itemBack);
    	this.close();
	}

	public save(): void {
    	ServicesFactoryInstance.DeclarationOethService.PrepareDeclarationsOeth(this.declarationCalculeeOETH.Id, () => {
    		NotificationServiceInstance.SendSuccess("La préparation de la déclaration a bien été enregistrée");
    		this.$emit("refresh");
    		this.$emit("refreshDsn");
    		this.close();
    	});
	}

	public close(): void {
    	$("#modalRapportOeth").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalRapportOeth/modalRapportOeth.ts